import clsx from "clsx";
import { Checkbox } from "@/shared/ui";

type Props = {
  id: string;
  checked: boolean;
  onChange?: (id: string) => void;
  text: string;
  isSecond: boolean;
  disabled?: boolean;
};

export default function HotelCkeckbox({ id, checked, onChange, text, isSecond, disabled }: Props) {
  return (
    <div className="relative flex items-center gap-2">
      {isSecond && (
        <div
          className="absolute -top-2 left-2 w-[1.25rem] h-5"
          style={{
            backgroundImage: `url(./svg/hotel/line.svg)`,
            backgroundSize: "contain",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />
      )}
      <Checkbox
        checked={checked}
        onChange={() => onChange(id)}
        variant="variant-3"
        className={clsx(isSecond && "ml-7", disabled && "pointer-events-none")}
      />
      <button
        className={clsx("text-14 font-bold leading-none", disabled && "pointer-events-none")}
        type="button"
        onClick={() => onChange(id)}
      >
        {text}
      </button>
    </div>
  );
}
